import BubbleInput from './components/BubbleInput';

function App() {
  return (
    <div className="App">
      <main className="main-content">
        <BubbleInput />
      </main>
    </div>
  );
}

export default App; 